module.exports = __webpack_public_path__ + "static/media/company_sample_csv.f73f1706.csv";